import React from 'react';
import { OigStatusChip } from '../../../../ui/features/shift-details/components/OigStatusChip';
import { useMissionsTranslation } from '../../../../ui/hooks';
import { AdminParticipantFullNameRenderer } from '../components/AdminParticipantFullNameRenderer';
export function useAdminParticipantTableColumns() {
    const { t } = useMissionsTranslation();
    return React.useMemo(() => [
        { value: 'positionName', label: t('shifts.rosterTable.positionName'), maxWidth: 244 },
        {
            value: 'participantFullName',
            label: t('shifts.rosterTable.participantFullName'),
            render: (row) => React.createElement(AdminParticipantFullNameRenderer, { row: row }),
        },
        { value: 'occupations', label: t('shifts.rosterTable.occupations'), maxWidth: 264 },
        { value: 'countyTribe', label: t('shifts.rosterTable.countyTribe'), maxWidth: 264 },
        {
            value: 'accountOigStatus',
            label: t('shifts.rosterTable.oigStatus'),
            render: (row) => React.createElement(OigStatusChip, { oigStatus: row.columns.accountOigStatus }),
        },
    ], [t]);
}
